import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import React from 'react';

const CustomSnackbar = ({
  open,
  onClose,
  message,
  isError,
  vertical,
  horizontal,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{
        vertical: vertical || 'top',
        horizontal: horizontal || 'right',
      }}
    >
      <Alert severity={`${isError ? 'error' : 'success'}`} className="w-full">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
